<header class="app-header">
  @if (authService.isAuthenticated$ | async) {
    <app-header />
    <app-idle-timeout-modal />
    <app-timeout-warning-modal />
  }
</header>
<main class="app-container">
  <div class="app-scroller">
    <router-outlet />
  </div>
</main>
